module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/relation_link_child_down-844973228028faeea2fdc76b62a5090e.png";